<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Construction',
  data () {
    return {
      msg: '建筑管理'
    }
  },
  created() {
  },  
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/BasicData/Construction/index.vue